export default __webpack_public_path__ + "static/media/050-mother.1547832c.png";